import { render, staticRenderFns } from "./BindTuiShuiInvoice.vue?vue&type=template&id=31817168&scoped=true"
import script from "./BindTuiShuiInvoice.vue?vue&type=script&lang=ts"
export * from "./BindTuiShuiInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31817168",
  null
  
)

export default component.exports